"use strict";
/**
 * Returns a flat list of messages, with grouping flags (showHeader, showUnreadIndicator)
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.useGroupedMessages = exports.groupMessages = exports.ChainCompromisedError = void 0;
var react_1 = __importDefault(require("react"));
var hasContent = function (m) {
    return (m.content.encrypted === false &&
        (m.content.text != null || m.content.image != null || m.content.file != null || m.content.video != null));
};
/**
 * Error thrown when a message chain has been compromised
 */
var ChainCompromisedError = /** @class */ (function (_super) {
    __extends(ChainCompromisedError, _super);
    function ChainCompromisedError(previous, current) {
        var _this = this;
        var _a;
        _this = _super.call(this, 'Message chain has been compromised. Previous message date: ' + previous.sentDate.toString() + ' does not satisfy expected: ' + ((_a = current.previousMessageDate) === null || _a === void 0 ? void 0 : _a.toString())) || this;
        _this.previous = previous;
        _this.current = current;
        _this._type = 'ChainCompromisedError';
        return _this;
    }
    ChainCompromisedError.is = function (err) {
        return (err === null || err === void 0 ? void 0 : err._type) === 'ChainCompromisedError';
    };
    return ChainCompromisedError;
}(Error));
exports.ChainCompromisedError = ChainCompromisedError;
function groupMessages(incomingMessages, lastRead, chatSessionCreated) {
    var messages = __spreadArray([], incomingMessages, true).filter(function (m) { return hasContent(m); }).sort(function (a, b) { return b.sentDate.valueOf() - a.sentDate.valueOf(); });
    return messages.map(function (message, index) {
        var previous = messages[index + 1];
        var showHeader = previous == null || previous.senderId !== message.senderId || Math.abs(previous.sentDate.valueOf() - message.sentDate.valueOf()) > 1000 * 60 * 5;
        // if(previous != null && previous.previousMessageDate != null && message.previousMessageDate != null && previous.sentDate < message.previousMessageDate) {
        //   // Message chain has been compromised, dump all cached messages and refresh from live
        //   console.error("Throwing a ChainCompromisedError", {
        //     previous, current: message
        //   });
        //   throw new ChainCompromisedError(previous, message);
        // } 
        return {
            message: message,
            showHeader: showHeader,
            showUnreadIndicator: lastRead != null &&
                message.sentDate < chatSessionCreated &&
                message.sentDate > lastRead &&
                (previous == null || lastRead > previous.sentDate)
        };
    });
}
exports.groupMessages = groupMessages;
// todo add reactions to grouped message type
function useGroupedMessages(opts) {
    return react_1["default"].useMemo(function () {
        return groupMessages(opts.messages.filter(hasContent), opts.lastReadRef.current, opts.chatSessionCreated);
    }, [opts.messages, opts.lastReadRef, opts.chatSessionCreated]);
}
exports.useGroupedMessages = useGroupedMessages;
